// Components/Footer/Footer.js
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        
        {/* Brand Section */}
        <div className={styles.brandSection}>
          <div className={styles.logoRow}>
            <img src="/logo192.png" alt="TrackMyFap" className={styles.logoImg} />
            <h3 className={styles.brandName}>TrackMyfap</h3>
          </div>
          <p className={styles.tagline}>Progress, Not Perfection</p>
        </div>
        
        {/* Quick Links */}
        <div className={styles.linksSection}>
          <Link to="/dashboard" className={styles.link}>Dashboard</Link>
          <Link to="/calendar" className={styles.link}>Calendar</Link>
          <Link to="/goals" className={styles.link}>Goals</Link>
          <Link to="/leaderboard" className={styles.link}>Leaderboard</Link>
          <Link to="/friends" className={styles.link}>Friends</Link>
          <Link to="/profile" className={styles.link}>Profile</Link>
        </div>
        
      </div>
      
      {/* Copyright Section */}
      <div className={styles.copyrightSection}>
        <p className={styles.copyrightText}>
          © {currentYear} TrackMyfap. All rights reserved.
        </p>
        <p className={styles.madeWith}>
          Built by One of You, For a Better You ❤️ 
        </p>
      </div>
    </footer>
  );
}

export default Footer;